import { render, staticRenderFns } from "./NominateMemberEdit.vue?vue&type=template&id=476a0a7a"
import script from "./NominateMemberEdit.vue?vue&type=script&lang=js"
export * from "./NominateMemberEdit.vue?vue&type=script&lang=js"
import style0 from "./NominateMemberEdit.vue?vue&type=style&index=0&id=476a0a7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports